import React, { Component } from 'react';
import { DragLayer } from 'react-dnd';

import styles from './CustomDragLayer.scss';
import { getTranslateFromCoordinates } from './helpers';

interface BareDragLayerProps {
  /** Starting mouse position, will be passed in automatically */
  startingOffset?: {
    x: number;
    y: number;
  };
  /** Function that receives the element index and returns the preview for that element */
  getPreview?: (...args: unknown[]) => unknown;
  /** Item is being dragged */
  isDragging?: boolean;
  /** Set item is being dragged */
  setIsDragging?: (...args: unknown[]) => unknown;
  /** Marks drag operation ended */
  didDrop?: boolean;
  /** Dragged item CSS height */
  draggedItemHeight?: number;
  /** Marks dragging down operation */
  isDraggingDown?: boolean;
  /** Marks dragging up operation */
  isDraggingUp?: boolean;
  /** Area taken by list */
  listBoundingReact?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  /** Index of dragged item */
  rowIndex?: number;
  /** Index of drop target */
  renderableDropTargetIndex?: number;
}

export class BareDragLayer extends Component<BareDragLayerProps> {
  static defaultProps = {
    startingOffset: null,
    isDragging: null,
    getPreview: null,
    didDrop: null,
    draggedItemHeight: null,
    isDraggingDown: null,
    isDraggingUp: null,
    listBoundingReact: null,
    rowIndex: null,
    renderableDropTargetIndex: null,
    setIsDragging: null
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { setIsDragging, isDragging, didDrop } = nextProps;

    setIsDragging(isDragging && !didDrop);
  }

  render() {
    const {
      didDrop,
      draggedItemHeight,
      getPreview,
      isDragging,
      isDraggingDown,
      isDraggingUp,
      listBoundingReact,
      rowIndex,
      startingOffset,
      renderableDropTargetIndex
    } = this.props;

    return (
      isDragging &&
      !didDrop && (
        <div style={{ pointerEvents: 'none' }}>
          {
            <div
              className={styles.drag_layer}
              style={{
                transform: getTranslateFromCoordinates(
                  startingOffset,
                  listBoundingReact,
                  draggedItemHeight
                )
              }}>
              <div>
                {getPreview({
                  rowIndex,
                  dropTargetIndex: renderableDropTargetIndex,
                  isDraggingUp,
                  isDraggingDown
                })}
              </div>
            </div>
          }
        </div>
      )
    );
  }
}

export const CustomDragLayer = DragLayer((monitor) => {
  const { dropTargetIndex, isDraggingDown, isDraggingUp, rowIndex, renderableDropTargetIndex } =
    monitor.getItem() || {};

  return {
    didDrop: monitor.didDrop(),
    dropTargetIndex,
    isDragging: monitor.isDragging(),
    isDraggingDown,
    isDraggingUp,
    rowIndex,
    startingOffset: monitor.getSourceClientOffset(),
    renderableDropTargetIndex
  };
})(BareDragLayer);
